import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import "./Events.css";
import { ListGroupItem, 
    ListGroup, 
    Glyphicon, 
    Button, 
    OverlayTrigger, 
    Tooltip, 
    DropdownButton, 
    MenuItem, 
    ButtonGroup, 
    Dropdown, 
    Checkbox,
    SplitButton
} from "react-bootstrap";
import { Link } from "react-router-dom";
// import { Modal } from "react-bootstrap";
import { View } from "react-native";
// import Select from "react-select";
import { 
    reformatDate, 
    reformatTime,
    reformatJustDate,
    getCap, 
    storeCap, 
    getUser, 
    getDefaultEventParameters,
    getUserInformation,
    timeDelta, 
    readableMonitorName,
    filterMonitorsByMonitorId,
    setDefaultEventParameters,
    addDaysToDate,
    filterOptions,
    makeMonitorFilter,
    removeDefaultEventParameters,
    isToday,
    timelineAnchorIsoFromPicker,
    ensurePickerWallClockDate,
    cloneEventParameters,
    findAnchorHighlightEventId,
    formatEventTimelineTime,
    formatEventTimelineDate,
    groupEventsForTimeline,
    getCapTitleLengthClass,
} from "../utils/Common";
import { 
    loadCap, 
    getMonitors, 
    deleteEventVideo, 
    recordUserAction, 
    getThumbUrl, 
    getCapEvents,
    getCapEventsAround,
    patchUserNotification,
    getLabelClasses,
    getEventDetections
} from '../utils/bedrockAPI';
import DateFnsUtils from '@date-io/date-fns';
import { ThemeProvider } from '@material-ui/styles';
import styled from 'styled-components';
import { DateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { createTheme } from "@material-ui/core/styles";
// import Replay from "./Replay";
import InfiniteScroll from "react-infinite-scroll-component";
import { ThreeDots } from "react-loader-spinner";
import MotionHistoryFilterModal from "../components/MotionHistoryFilterModal";
import FootageModal from "../components/FootageModal";
import MotionEvent from "./MotionEvent";
import ZonesModal from "../components/ZonesModal";
import {
    useMotionHistoryLayout,
    isEnhancedMotionHistoryLayout,
} from "../dev/motionHistoryLayout";

// import { CalendarPicker, RangePicker } from 'react-minimal-datetime-range';
// import 'react-minimal-datetime-range/lib/react-minimal-datetime-range.min.css';
// import DateTimeRangePicker from '@wojtekmaj/react-datetimerange-picker';
// import DatePicker from "react-datepicker";
// import LoaderButton from '../components/LoaderButton';

// const sorts = ["Sort by: Newest","Sort by: Oldest","Sort by: Name (A-Z)", "Sort by: Name (Z-A)", "Sort by: Longest", "Sort by: Shortest"];
const sorts = ["Sort: Newest","Sort: Oldest","Sort: Name (A-Z)", "Sort: Name (Z-A)"]; // TODO: Fix longest/shortest
// const sortsOrderBysCaptures = ["capture_date DESC","caputer_date ASC","name ASC","name DESC", "length DESC", "length ASC"];
// const sortsOrderBysEvents = ["startDate DESC","startDate ASC","name ASC","name DESC","time DESC", "time ASC"];
const sortsOrderBysEvents = ["startDate DESC","startDate ASC","name ASC","name DESC"]; // TODO: Fix longest/shortest

const TIMELINE_LIMIT_BEFORE = 20;
const TIMELINE_LIMIT_AFTER = 25;
const TIMELINE_PAGE_LIMIT = 20;

function usesNewestTimeline(sortParameterNumber) {
    return sortParameterNumber === 0;
}

function anchorEventDomId(eventId) {
    return `event-anchor-${String(eventId)}`;
}

function eventIdsMatch(a, b) {
    return a != null && b != null && String(a) === String(b);
}

function scrollTimelineToEvent(container, eventId) {
    if (!container || eventId == null) {
        return false;
    }
    const el = document.getElementById(anchorEventDomId(eventId));
    if (!el) {
        return false;
    }
    const elRect = el.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();
    const offset = elRect.top - containerRect.top + container.scrollTop;
    container.scrollTop =
        offset - container.clientHeight / 2 + el.clientHeight / 2;
    return true;
}

function supportsDetectionApi(capToCheck) {
    return capToCheck && capToCheck.architecture && (capToCheck.architecture.includes("2CAM") || capToCheck.architecture.includes("4CAM"));
}

/* Brand theme for the MUI date/time picker popup (renders in a portal,
   so it's styled via theme rather than scoped CSS). Bumps all type sizes up. */
function makeBrandPickerTheme(sz) {
    return createTheme({
        typography: {
            fontFamily: "'Normalidad', 'Open Sans', sans-serif",
            h3: { fontSize: sz.h3 },
            h4: { fontSize: sz.h4 },
            subtitle1: { fontSize: sz.subtitle1 },
            body1: { fontSize: sz.body1 },
            body2: { fontSize: sz.body2 },
            caption: { fontSize: sz.caption },
            button: { fontSize: sz.button, fontWeight: 600 },
        },
        palette: {
            primary: { main: "#262626" },
            secondary: { main: "#E6FF2F" },
        },
        overrides: {
            MuiPickersBasePicker: {
                pickerView: {
                    minWidth: sz.viewMinWidth,
                    maxWidth: sz.viewMaxWidth,
                    minHeight: sz.viewMinHeight,
                },
            },
            MuiPickersToolbar: {
                toolbar: { backgroundColor: "#262626" },
            },
            MuiPickersToolbarText: {
                toolbarTxt: { color: "rgba(255, 255, 255, 0.6)" },
                toolbarBtnSelected: { color: "#E6FF2F" },
            },
            MuiPickersCalendarHeader: {
                dayLabel: { width: sz.daySize, fontSize: sz.caption, color: "#86878B" },
                iconButton: { color: "#262626" },
            },
            MuiPickersCalendar: {
                transitionContainer: { minHeight: sz.calendarMinHeight },
            },
            MuiPickersDay: {
                day: { width: sz.daySize, height: sz.daySize, color: "#262626" },
                daySelected: {
                    backgroundColor: "#262626",
                    color: "#E6FF2F",
                    "&:hover": { backgroundColor: "#1a1a1a" },
                },
                current: { color: "#262626", fontWeight: 700 },
            },
            MuiPickersYear: {
                root: { fontSize: sz.body1 },
                yearSelected: { color: "#262626" },
            },
            MuiPickersClock: {
                clock: { backgroundColor: "#F2F0EB" },
                pin: { backgroundColor: "#262626" },
            },
            MuiPickersClockPointer: {
                pointer: { backgroundColor: "#262626" },
                thumb: { borderColor: "#262626" },
                noPoint: { backgroundColor: "#262626" },
            },
            MuiPickersClockNumber: {
                clockNumber: { fontSize: sz.body1, color: "#262626" },
            },
            MuiTabs: {
                indicator: { backgroundColor: "#E6FF2F", height: 3 },
            },
            MuiButton: {
                textPrimary: { color: "#262626" },
            },
            MuiDialog: {
                paper: { borderRadius: 6 },
            },
        },
    });
}

const brandPickerThemeMobile = makeBrandPickerTheme({
    h3: "2.6rem",
    h4: "2.1rem",
    subtitle1: "1.2rem",
    body1: "1.1rem",
    body2: "1.05rem",
    caption: "0.95rem",
    button: "1rem",
    viewMinWidth: 340,
    viewMaxWidth: 400,
    viewMinHeight: 410,
    daySize: 44,
    calendarMinHeight: 250,
});

const brandPickerThemeDesktop = makeBrandPickerTheme({
    h3: "3.4rem",
    h4: "2.8rem",
    subtitle1: "1.6rem",
    body1: "1.4rem",
    body2: "1.35rem",
    caption: "1.15rem",
    button: "1.2rem",
    viewMinWidth: 420,
    viewMaxWidth: 480,
    viewMinHeight: 500,
    daySize: 54,
    calendarMinHeight: 340,
});

const DesktopDateTimePicker = styled(DateTimePicker)`
    & .MuiInputBase-input {
        font-family: var(--brand-font);
        font-size: 18px;
        color: var(--brand-slate);
        border: 1px solid var(--brand-slate);
        padding: 5px 5px 5px 36px;
        cursor: pointer;
        text-align: center;
        max-width: 240px;
        min-height: 40px;
        border-radius: var(--brand-radius);
    }
    
    & .MuiInputBase-input:hover {
        background-color: #F5F5F5;
    }
`;

const MobileDateTimePicker = styled(DateTimePicker)`
    & .MuiInputBase-input {
        font-family: var(--brand-font);
        font-size: 12px;
        color: var(--brand-slate);
        border: 1px solid var(--brand-slate);
        padding: 5px 5px 5px 26px;
        cursor: pointer;
        text-align: center;
        max-width: 140px;
        min-height: 25px;
        border-radius: var(--brand-radius);
    }
    
    & .MuiInputBase-input:hover {
        background-color: #F5F5F5;
    }
`;

export default function Events2(props) {
    const motionHistoryLayout = useMotionHistoryLayout();
    const useEnhancedMotionHistory = isEnhancedMotionHistoryLayout(motionHistoryLayout);
    const [cap, setCap] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [events, setEvents] = useState([]);
    const [nextPageEvents, setNextPageEvents] = useState(null);
    const [monitors, setMonitors] = useState(null);
    const [renderError, setRenderError] = useState(false);
    const [buttonSize, setButtonSize] = useState("large");
    const [showFootage, setShowFootage] = useState(false);
    const [footageStartDate, setFootageStartDate] = useState(null);
    const [footageMonitor, setFootageMonitor] = useState(null);
    const [footageCameraOffsetMinutes, setFootageCameraOffsetMinutes] = useState(null);
    // const [expandables, setExpandables] = useState([]);

    var tempSelectedFilters = {}
    for(var i=0; i<filterOptions.length; i++) {
        tempSelectedFilters[filterOptions[i]] = true;
    }
    const tempEventParams = {
        selectedFilters:tempSelectedFilters,
        realMotion:true,
        pageNumber:0,
        sortParameterNumber:0,
        daylight:true,
        startDate:addDaysToDate(new Date(),-7),
        endDate:new Date(),
        cars:true,
        persons:true
    }
    const [eventParameters, setEventParameters] = useState(tempEventParams);
    // const [daylightFilter, setDaylightFilter] = useState({daylight:true,night:true});
    const [time, setTime] = useState(0);
    const [thumbs, setThumbs] = useState({});
    const [loadingThumbs, setLoadingThumbs] = useState({});
    const [labelClasses, setLabelClasses] = useState(null);
    const [eventDetections, setEventDetections] = useState({});
    const [showFilterModal, setShowFilterModal] = useState(false);
    const [showZonesModal, setShowZonesModal] = useState(false);
    const [openEventId, setOpenEventId] = useState(null);
    const [playbackSpeed, setPlaybackSpeed] = useState(1);
    const [hasMoreOlderTimeline, setHasMoreOlderTimeline] = useState(false);
    const [hasMoreNewerTimeline, setHasMoreNewerTimeline] = useState(false);
    const [timelineCursors, setTimelineCursors] = useState({ oldest: null, newest: null });
    const [anchorHighlightId, setAnchorHighlightId] = useState(null);
    const [anchorNavigateToken, setAnchorNavigateToken] = useState(0);
    const componentMounted = useRef(true);
    const loadingDetections = useRef({});
    const loadingOlderTimeline = useRef(false);
    const loadingNewerTimeline = useRef(false);
    const [loadingNewerUi, setLoadingNewerUi] = useState(false);
    const scrollContainerRef = useRef(null);
    const loadNewerSentinelRef = useRef(null);
    const scrollRestorePending = useRef(null);
    const anchorNavigateTargetRef = useRef(null);
    const anchorNavigationActiveRef = useRef(false);
    const anchorScrollCleanupRef = useRef(null);

    useEffect(() => {
        if(window.innerWidth<767) {
            setButtonSize("small");
        }
        
        const handleResize = () => {
            setButtonSize(window.innerWidth < 768 ? "small" : "large");
        };
        
        const handleMouseDown = (e) => {
            // Prevent middle mouse button (wheel click) default behavior
            if (e.button === 1) {
                e.preventDefault();
                e.stopPropagation();
                return false;
            }
        };
        
        const handleMouseUp = (e) => {
            // Prevent middle mouse button (wheel click) default behavior
            if (e.button === 1) {
                e.preventDefault();
                e.stopPropagation();
                return false;
            }
        };
        
        window.addEventListener('resize', handleResize);
        document.addEventListener('mousedown', handleMouseDown);
        document.addEventListener('mouseup', handleMouseUp);
        
        const interval = setInterval(() => {
            setTime(time => time+1);
        },500);
        
        return () => {
            clearInterval(interval);
            window.removeEventListener('resize', handleResize);
            document.removeEventListener('mousedown', handleMouseDown);
            document.removeEventListener('mouseup', handleMouseUp);
            componentMounted.current = false; // Master Component unmounted command for async functions
            if (anchorScrollCleanupRef.current) {
                anchorScrollCleanupRef.current();
            }
        };
    },[]);

    // Events that can be opened in the playback overlay (same filter as the list)
    function getPlayableEvents() {
        if(!events) return [];
        return events.filter((ev) => ev.url && ev.status === "IN_S3");
    }

    function getAdjacentEventId(delta) {
        if(!openEventId) return null;
        const playable = getPlayableEvents();
        const idx = playable.findIndex((ev) => ev.eventId === openEventId);
        if(idx === -1) return null;
        const neighbor = playable[idx + delta];
        return neighbor ? neighbor.eventId : null;
    }

    // Event playback overlay: lock page scroll, close on Escape, arrow keys navigate
    useEffect(() => {
        if(!openEventId) return;
        function handleKeyDown(e) {
            // While in browser fullscreen, Escape only exits fullscreen
            if(e.key === "Escape" && !document.fullscreenElement && !document.webkitFullscreenElement) {
                setOpenEventId(null);
            } else if(e.key === "ArrowLeft" || e.key === "ArrowRight") {
                const neighborId = getAdjacentEventId(e.key === "ArrowLeft" ? -1 : 1);
                if(neighborId) setOpenEventId(neighborId);
            }
        }
        window.addEventListener("keydown", handleKeyDown);
        document.body.classList.add("brand-overlay-open");
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
            document.body.classList.remove("brand-overlay-open");
        };
    },[openEventId, events]);

    useEffect(() => {
        if(props.match.params.notificationid) {
            const update = {clickDate:new Date()};
            patchUserNotification(props.match.params.notificationid,update);
        }
    },[props.match.params.notificationid])

    useEffect(() => {
        let isMounted = true;
        async function accessCap() {
            try {
                setIsLoading(true);
                var tempCap = getCap();
                if(tempCap == null || tempCap.capId !== props.match.params.capid  || !tempCap.architecture) {
                    tempCap = await loadCap(props.match.params.capid);
                    if(isMounted)
                        storeCap(tempCap);
                }
                if(isMounted) {
                    setCap(tempCap);
                    const tempMonitors = await getMonitors(props.match.params.capid);
                    // setMonitors(filterMonitorsByMode(tempMonitors,"Modect"));
                    if(isMounted) {
                        setMonitors(tempMonitors);
                        setIsLoading(false);
                    }
                }
            } catch(e) {
                if(isMounted)
                    setRenderError(true);
            }
        }
        var storedParameters = getDefaultEventParameters();
        if(storedParameters && storedParameters[props.match.params.capid]) {
            setEventParameters(storedParameters[props.match.params.capid]);
            // console.log("from storage",storedParameters);
        }
        setEventDetections({});
        loadingDetections.current = {};
        accessCap();
        recordUserAction(getUser().userId,"events",props.match.params.capid,{'userData':getUserInformation()});
        return () => { isMounted = false; };
    },[props.match.params.capid]);

    useEffect(() => {
        let isMounted = true;

        async function fetchLabelClasses() {
            try {
                const tempLabelClasses = await getLabelClasses();
                if(isMounted) {
                    setLabelClasses(tempLabelClasses);
                }
            } catch (error) {
                console.error("Failed to load label classes:", error);
                if(isMounted) {
                    setLabelClasses([]);
                }
            }
        }

        if(supportsDetectionApi(cap) && labelClasses===null) {
            fetchLabelClasses();
        }

        return () => { isMounted = false; };
    },[cap,labelClasses]);

    useEffect(() => {
        if (anchorNavigateToken === 0) {
            return;
        }
        const eventId = anchorNavigateTargetRef.current;
        if (
            eventId == null ||
            !events ||
            events.length === 0 ||
            !events.some((e) => eventIdsMatch(e.eventId, eventId))
        ) {
            return;
        }

        let cancelled = false;
        anchorNavigationActiveRef.current = true;

        const finishNavigation = () => {
            anchorNavigationActiveRef.current = false;
        };

        const attempt = () => {
            if (cancelled) {
                return true;
            }
            return scrollTimelineToEvent(scrollContainerRef.current, eventId);
        };

        if (attempt()) {
            finishNavigation();
            return;
        }

        const timeouts = [];
        const run = () => {
            if (attempt()) {
                finishNavigation();
            }
        };
        const raf1 = requestAnimationFrame(() => {
            if (attempt()) {
                finishNavigation();
                return;
            }
            requestAnimationFrame(run);
        });
        [100, 300, 600, 1200].forEach((ms) => {
            timeouts.push(setTimeout(run, ms));
        });
        timeouts.push(setTimeout(finishNavigation, 1500));

        const cleanup = () => {
            cancelled = true;
            cancelAnimationFrame(raf1);
            timeouts.forEach(clearTimeout);
            finishNavigation();
        };
        anchorScrollCleanupRef.current = cleanup;

        return cleanup;
    }, [anchorNavigateToken]);

    useLayoutEffect(() => {
        const pending = scrollRestorePending.current;
        const container = scrollContainerRef.current;
        if (!pending || !container) return;
        container.scrollTop = pending.scrollTop + (container.scrollHeight - pending.scrollHeight);
        scrollRestorePending.current = null;
    }, [events]);

    useEffect(() => {
        let isMounted = true;

        async function findThumbs() {
            // Create a batch of thumbnail requests
            const thumbRequests = events
                .filter(event => event.imageId && !thumbs[event.eventId] && !loadingThumbs[event.eventId])
                .map(async (event) => {
                    try {
                        setLoadingThumbs(prev => ({...prev, [event.eventId]: true}));
                        const tempThumb = await getThumbUrl(event.imageId);
                        if (isMounted) {
                            setThumbs(prev => ({...prev, [event.eventId]: tempThumb}));
                            setLoadingThumbs(prev => ({...prev, [event.eventId]: false}));
                        }
                    } catch (error) {
                        console.error(`Failed to load thumbnail for event ${event.eventId}:`, error);
                        if (isMounted) {
                            setLoadingThumbs(prev => ({...prev, [event.eventId]: false}));
                        }
                    }
                });

            // Process thumbnails in batches of 5
            const batchSize = 5;
            for (let i = 0; i < thumbRequests.length; i += batchSize) {
                const batch = thumbRequests.slice(i, i + batchSize);
                await Promise.all(batch);
            }
        }

        if (events && events.length > 0) {
            findThumbs();
        }
        return () => { isMounted = false; };
    }, [events]);

    useEffect(() => {
        let isMounted = true;

        async function findEventDetections() {
            const labelClassLookup = {};
            for(let i=0; i<labelClasses.length; i++) {
                const row = labelClasses[i];
                const id = row.labelClassId || row.label_class_id;
                if(id) {
                    labelClassLookup[id] = row.name;
                }
            }

            const detectionRequests = events
                .filter(event => event.eventId && eventDetections[event.eventId]===undefined && !loadingDetections.current[event.eventId])
                .map(async (event) => {
                    try {
                        loadingDetections.current[event.eventId] = true;
                        const detections = await getEventDetections(event.eventId);
                        const detectionNames = [];
                        const detectedClassIds = new Set();
                        if(detections && detections.length > 0) {
                            for(let i=0; i<detections.length; i++) {
                                const labelClassId = detections[i].labelClassId || detections[i].label_class_id;
                                const labelName = labelClassLookup[labelClassId];
                                if(labelName && !detectedClassIds.has(labelClassId)) {
                                    detectedClassIds.add(labelClassId);
                                    detectionNames.push(labelName);
                                }
                            }
                        }
                        if(isMounted) {
                            setEventDetections(prev => ({...prev, [event.eventId]: detectionNames}));
                        }
                    } catch (error) {
                        console.error(`Failed to load detections for event ${event.eventId}:`, error);
                        if(isMounted) {
                            setEventDetections(prev => ({...prev, [event.eventId]: []}));
                        }
                    } finally {
                        loadingDetections.current[event.eventId] = false;
                    }
                });

            const batchSize = 5;
            for(let i=0; i<detectionRequests.length; i+=batchSize) {
                const batch = detectionRequests.slice(i,i+batchSize);
                await Promise.all(batch);
            }
        }

        if(supportsDetectionApi(cap) && events && events.length > 0 && labelClasses && labelClasses.length > 0) {
            findEventDetections();
        }

        return () => { isMounted = false; };
    },[cap,events,labelClasses,eventDetections]);

    // useEffect(() => {
    //     if(expandables) console.log(expandables);
    // },[expandables]);

    const changeStartTime = function(startTime) {
        if(cap!==null && events!=null) {
            changePage(0,eventParameters.sortParameterNumber,0,eventParameters.selectedFilters,eventParameters.realMotion,startTime,eventParameters.endDate,eventParameters.cars,eventParameters.persons,true)
        }
    }

    const changeEndTime = function(endTime) {
        if (cap === null) return;
        const wallEnd = ensurePickerWallClockDate(endTime);
        if (usesNewestTimeline(eventParameters.sortParameterNumber)) {
            loadAroundTimeline(
                wallEnd,
                true,
                eventParameters.selectedFilters,
                eventParameters.realMotion,
                eventParameters.cars,
                eventParameters.persons,
            );
        } else if (events !== null) {
            changePage(
                0,
                eventParameters.sortParameterNumber,
                0,
                eventParameters.selectedFilters,
                eventParameters.realMotion,
                addDaysToDate(endTime, -7),
                endTime,
                eventParameters.cars,
                eventParameters.persons,
                true,
            );
        }
    }

    async function loadAroundTimeline(anchorDate, reset, selectedMonitors, real, cars, persons) {
        if (!cap || !monitors) return;
        anchorDate = ensurePickerWallClockDate(anchorDate);
        if (reset) {
            setIsLoading(true);
            setEvents(null);
            setNextPageEvents(null);
            setHasMoreOlderTimeline(false);
            setHasMoreNewerTimeline(false);
            setTimelineCursors({ oldest: null, newest: null });
            setAnchorHighlightId(null);
            anchorNavigateTargetRef.current = null;
            scrollRestorePending.current = null;
            if (anchorScrollCleanupRef.current) {
                anchorScrollCleanupRef.current();
                anchorScrollCleanupRef.current = null;
            }
            anchorNavigationActiveRef.current = false;
        }
        setTime(0);
        const anchorIso = timelineAnchorIsoFromPicker(anchorDate);
        const monitorIds = makeMonitorFilter(monitors, selectedMonitors);
        var storedEventParameters = getDefaultEventParameters();
        if (!storedEventParameters) storedEventParameters = {};
        if (!storedEventParameters[cap.capId]) storedEventParameters[cap.capId] = {};
        var tempEventParams = {
            ...cloneEventParameters(eventParameters),
            pageNumber: 0,
            selectedFilters: selectedMonitors,
            realMotion: real,
            endDate: anchorDate,
            startDate: anchorDate,
            cars,
            persons,
        };
        setEventParameters(tempEventParams);
        storedEventParameters[cap.capId] = tempEventParams;
        setDefaultEventParameters(storedEventParameters);

        try {
            const data = await getCapEventsAround(cap.capId, {
                mode: "around",
                anchor: anchorIso,
                limitBefore: TIMELINE_LIMIT_BEFORE,
                limitAfter: TIMELINE_LIMIT_AFTER,
                realMotion: real,
                cars,
                persons,
                monitors: monitorIds,
            });
            if (!componentMounted.current) return;
            const loaded = data.events || [];
            const displayable = loaded.filter(
                (e) => e.url && e.status && e.status === "IN_S3",
            );
            const highlightId = findAnchorHighlightEventId(
                displayable.length > 0 ? displayable : loaded,
                anchorDate,
            );
            setEvents(loaded);
            setHasMoreOlderTimeline(!!data.hasMoreOlder);
            setHasMoreNewerTimeline(!!data.hasMoreNewer);
            setTimelineCursors({
                oldest: data.oldest || null,
                newest: data.newest || null,
            });
            setAnchorHighlightId(highlightId);
            if (highlightId != null) {
                anchorNavigateTargetRef.current = highlightId;
                setAnchorNavigateToken((t) => t + 1);
            } else {
                anchorNavigateTargetRef.current = null;
            }
        } catch (e) {
            console.error("loadAroundTimeline failed", e);
            if (componentMounted.current) {
                setEvents([]);
                setHasMoreOlderTimeline(false);
            }
        } finally {
            if (reset && componentMounted.current) {
                setIsLoading(false);
            }
        }
    }

    async function loadOlderAroundTimeline() {
        if (!cap || !monitors || loadingOlderTimeline.current || !hasMoreOlderTimeline) return;
        const oldest = timelineCursors.oldest;
        if (!oldest || !oldest.startDate || !oldest.eventId) return;

        loadingOlderTimeline.current = true;
        const monitorIds = makeMonitorFilter(monitors, eventParameters.selectedFilters);
        try {
            const data = await getCapEventsAround(cap.capId, {
                mode: "before",
                cursorStart: oldest.startDate,
                cursorEventId: oldest.eventId,
                limit: TIMELINE_PAGE_LIMIT,
                realMotion: eventParameters.realMotion,
                cars: eventParameters.cars,
                persons: eventParameters.persons,
                monitors: monitorIds,
            });
            if (!componentMounted.current) return;
            setEvents((prev) => {
                const existing = prev || [];
                const seen = new Set(existing.map((e) => e.eventId));
                const added = (data.events || []).filter((e) => e.eventId && !seen.has(e.eventId));
                return [...existing, ...added];
            });
            setHasMoreOlderTimeline(!!data.hasMoreOlder);
            if (data.oldest) {
                setTimelineCursors((c) => ({ ...c, oldest: data.oldest }));
            }
        } catch (e) {
            console.error("loadOlderAroundTimeline failed", e);
        } finally {
            loadingOlderTimeline.current = false;
        }
    }

    async function loadNewerAroundTimeline() {
        if (!cap || !monitors || loadingNewerTimeline.current || !hasMoreNewerTimeline) return;
        const newest = timelineCursors.newest;
        if (!newest || !newest.startDate || !newest.eventId) return;

        loadingNewerTimeline.current = true;
        setLoadingNewerUi(true);
        const container = scrollContainerRef.current;
        if (container) {
            scrollRestorePending.current = {
                scrollTop: container.scrollTop,
                scrollHeight: container.scrollHeight,
            };
        }
        const monitorIds = makeMonitorFilter(monitors, eventParameters.selectedFilters);
        try {
            const data = await getCapEventsAround(cap.capId, {
                mode: "after",
                cursorStart: newest.startDate,
                cursorEventId: newest.eventId,
                limit: TIMELINE_PAGE_LIMIT,
                realMotion: eventParameters.realMotion,
                cars: eventParameters.cars,
                persons: eventParameters.persons,
                monitors: monitorIds,
            });
            if (!componentMounted.current) return;
            setEvents((prev) => {
                const existing = prev || [];
                const seen = new Set(existing.map((e) => e.eventId));
                const added = (data.events || []).filter(
                    (e) => e.eventId && !seen.has(e.eventId),
                );
                return [...added, ...existing];
            });
            setHasMoreNewerTimeline(!!data.hasMoreNewer);
            if (data.newest) {
                setTimelineCursors((c) => ({ ...c, newest: data.newest }));
            }
        } catch (e) {
            console.error("loadNewerAroundTimeline failed", e);
            scrollRestorePending.current = null;
        } finally {
            loadingNewerTimeline.current = false;
            setLoadingNewerUi(false);
        }
    }

    useEffect(() => {
        if (!usesNewestTimeline(eventParameters.sortParameterNumber)) return;
        const root = scrollContainerRef.current;
        const sentinel = loadNewerSentinelRef.current;
        if (!root || !sentinel) return;

        const observer = new IntersectionObserver(
            (entries) => {
                const entry = entries[0];
                if (
                    !entry ||
                    !entry.isIntersecting ||
                    loadingNewerTimeline.current ||
                    !hasMoreNewerTimeline ||
                    anchorNavigationActiveRef.current ||
                    root.scrollTop > 64
                ) {
                    return;
                }
                loadNewerAroundTimeline();
            },
            { root, rootMargin: "0px", threshold: 0 },
        );
        observer.observe(sentinel);
        return () => observer.disconnect();
    }, [
        eventParameters.sortParameterNumber,
        hasMoreNewerTimeline,
        events,
        cap,
        monitors,
    ]);

    // async function changePage(n,sortParamater,pn,selectedMonitors=null,real=null,sd=null,ed=null,df=null,dmit=null,cars=null,persons=null) {
    async function changePage(n,sortParamater,pn,selectedMonitors=null,real=null,sd=null,ed=null,cars=null,persons=null,reset=false) {
        if (usesNewestTimeline(sortParamater)) {
            await loadAroundTimeline(
                ed || eventParameters.endDate,
                true,
                selectedMonitors,
                real,
                cars,
                persons,
            );
            return;
        }
        // console.log(n,sortParamater,pn,selectedMonitors,real);
        if(reset) {
            setIsLoading(true); // -- INFINITE
            setEvents(null); // -- INFINITE
            setNextPageEvents(null); // -- INFINITE
        }
        setTime(0);
        var storedEventParameters = getDefaultEventParameters();
        if(!storedEventParameters) storedEventParameters = {};
        if(!storedEventParameters[cap.capId]) storedEventParameters[cap.capId] = {};
        if(real==null) real = eventParameters.realMotion;
        var monitorIds = makeMonitorFilter(monitors,selectedMonitors);
        var daylight = null;
        var tempEventParams = cloneEventParameters(eventParameters);
        tempEventParams.pageNumber = pn+n;
        tempEventParams.sortParameterNumber = sortParamater;
        tempEventParams.selectedFilters = selectedMonitors;
        tempEventParams.realMotion = real;
        tempEventParams.daylight = daylight;
        if (sd != null) tempEventParams.startDate = ensurePickerWallClockDate(sd);
        if (ed != null) tempEventParams.endDate = ensurePickerWallClockDate(ed);
        tempEventParams.cars = cars;
        tempEventParams.persons = persons;
        setEventParameters(tempEventParams);
        storedEventParameters[cap.capId] = tempEventParams;
        setDefaultEventParameters(storedEventParameters);
        var startDateCall = null;
        var endDateCall = null;
        if(sd) {
            startDateCall = sd.toLocaleString("en-US",{timezone:"UTC"});
        }
        if(ed) {
            endDateCall = ed.toLocaleString("en-US",{timezone:"UTC"});
        }
        // if(!df) df = daylightFilter;
        // if(df.daylight && !df.night) daylight = true;
        // if(df.night && !df.daylight) daylight = false;
        // if(!df.night && !df.daylight) daylight = 'none';
        // setDefaultEventParameters(storedEventParameters);
        // console.log("setting",storedEventParameters[cap.capId].endDate);
        const tempEvents = await getCapEvents(cap.capId,pn+n,sortsOrderBysEvents[sortParamater],daylight,real,monitorIds,startDateCall,endDateCall,cars,persons);
        if(componentMounted.current) {
            if(reset) {
                setEvents(tempEvents); // -- INFINITE
            } else {
                setEvents(events => {
                    const existingEvents = events || [];
                    const existingEventIds = new Set(existingEvents.map(e => e.eventId));
                    const newUniqueEvents = tempEvents.filter(e => !existingEventIds.has(e.eventId));
                    const duplicateCount = tempEvents.length - newUniqueEvents.length;
                    if (duplicateCount > 0) {
                        console.warn(`Filtered out ${duplicateCount} duplicate events during infinite scroll`);
                    }
                    return [...existingEvents, ...newUniqueEvents];
                });
            }
            const tempNextPageEvents = await getCapEvents(cap.capId,pn+n+1,sortsOrderBysEvents[sortParamater],daylight,real,monitorIds,startDateCall,endDateCall,cars,persons);
            if(componentMounted.current) {
                setNextPageEvents(tempNextPageEvents);
            }
        
            // storedDaylightParameter[cap.capId] = daylightFilter;
            if(reset) {
                setIsLoading(false); // -- INFINITE
            }
        }
    }

    var prevPage = function () {
        changePage(-1,eventParameters.sortParameterNumber,eventParameters.pageNumber,eventParameters.selectedFilters,eventParameters.realMotion,eventParameters.startDate,eventParameters.endDate,eventParameters.cars,eventParameters.persons);
    }

    var nextPage = function () {
        if (usesNewestTimeline(eventParameters.sortParameterNumber)) {
            loadOlderAroundTimeline();
        } else {
            changePage(+1,eventParameters.sortParameterNumber,eventParameters.pageNumber,eventParameters.selectedFilters,eventParameters.realMotion,eventParameters.startDate,eventParameters.endDate,eventParameters.cars,eventParameters.persons);
        }
    }

    var refreshPage = function () {
        const anchorDate = ensurePickerWallClockDate(eventParameters.endDate);
        if (usesNewestTimeline(eventParameters.sortParameterNumber)) {
            loadAroundTimeline(
                anchorDate,
                true,
                eventParameters.selectedFilters,
                eventParameters.realMotion,
                eventParameters.cars,
                eventParameters.persons,
            );
        } else {
            changePage(0,eventParameters.sortParameterNumber,0,eventParameters.selectedFilters,eventParameters.realMotion,eventParameters.startDate,eventParameters.endDate,eventParameters.cars,eventParameters.persons,true);
        }
    }

    useEffect(() => {
        if (!cap || !monitors) return;
        let cancelled = false;
        (async () => {
            setIsLoading(true);
            try {
                if (usesNewestTimeline(eventParameters.sortParameterNumber)) {
                    await loadAroundTimeline(
                        eventParameters.endDate,
                        true,
                        eventParameters.selectedFilters,
                        eventParameters.realMotion,
                        eventParameters.cars,
                        eventParameters.persons,
                    );
                } else if (cap.architecture && cap.architecture.includes("JETSON")) {
                    await changePage(
                        0,
                        eventParameters.sortParameterNumber,
                        0,
                        eventParameters.selectedFilters,
                        eventParameters.realMotion,
                        eventParameters.startDate,
                        eventParameters.endDate,
                        eventParameters.cars,
                        eventParameters.persons,
                        true,
                    );
                }
            } finally {
                if (!cancelled) setIsLoading(false);
            }
        })();
        return () => { cancelled = true; };
    },[cap,monitors]);

    function renderPageButtons(buttonType="default") {
        if (events) {
            return (
                <ButtonGroup>
                    <Button
                        bsStyle={buttonType}
                        bsSize={buttonSize}
                        onClick={prevPage}
                        disabled={eventParameters.pageNumber===0}
                    >
                        <Glyphicon glyph="arrow-left" />
                    </Button>
                    <Button
                        disabled={true}
                        bsStyle={buttonType}
                        bsSize={buttonSize}
                    >
                        {eventParameters.pageNumber+1}
                    </Button>
                    <Button
                        bsStyle={buttonType}
                        bsSize={buttonSize}
                        onClick={nextPage}
                        disabled={!nextPageEvents || nextPageEvents.length===0}
                    >
                        <Glyphicon glyph="arrow-right" />
                    </Button>
                </ButtonGroup>
            );
        }
    }

    function renderEventsList() {
        async function removeEvent(event) {
            setIsLoading(true);
            if(window.confirm(`Are you sure you wish to delete ${event.name}?`)) {
                await deleteEventVideo(event.eventId);
                if(events && events.length > 0) {
                    let tempEvents = [];
                    for(let i=0; i<events.length; i++) {
                        if(events[i].eventId!==event.eventId) {
                            tempEvents.push(events[i]);
                        }
                    }
                    setEvents(tempEvents);
                }
            }
            setIsLoading(false);
        }
        const snapshotTooltip = (
            <Tooltip id="snapshot" style={{fontSize:"18px"}} disabled={buttonSize==="small"}>
                Ultra-High Resolution Snapshot
            </Tooltip>
        );
        const deleteTooltip = (
            <Tooltip id="delete" style={{fontSize:"18px"}} disabled={buttonSize==="small"}>
                Delete Event
            </Tooltip>
        );
        const videoTooltip = (
            <Tooltip id="delete" style={{fontSize:"18px"}} disabled={buttonSize==="small"}>
                Motion Video
            </Tooltip>
        );
        function capitalizeFirstLetter(string) {
            if(!string) return "";
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
        function getDetectionNames(event) {
            const names = [];
            const seenLower = new Set();
            function addLabelName(n) {
                if(!n) return;
                const key = String(n).toLowerCase();
                if(seenLower.has(key)) return;
                seenLower.add(key);
                names.push(capitalizeFirstLetter(n));
            }
            if(supportsDetectionApi(cap)) {
                const apiNames = eventDetections[event.eventId];
                if(apiNames && apiNames.length > 0) {
                    for(let i=0; i<apiNames.length; i++) {
                        addLabelName(apiNames[i]);
                    }
                }
            }
            if(event.analysis && event.analysis.yolo) {
                for(let j=0; j<event.analysis.yolo.length; j++) {
                    addLabelName(event.analysis.yolo[j].class);
                }
            }
            return names;
        }
        // function setExpanded(expandableIndex) {
        //     let tempExpandables = [...expandables];
        //     tempExpandables[expandableIndex] = !expandables[expandableIndex];
        //     setExpandables(tempExpandables);
        // }

        function renderEventRow(event) {
            const isAnchorRow = eventIdsMatch(event.eventId, anchorHighlightId);
            const detectionNames = getDetectionNames(event);
            const isUnverified = event.analysis && event.analysis.real === false;

            if (!(event.url && event.status && event.status === "IN_S3")) {
                return null;
            }

            return (
                <div
                    key={event.eventId}
                    id={isAnchorRow ? anchorEventDomId(event.eventId) : undefined}
                    className={isAnchorRow ? "event-row-anchor-highlight" : undefined}
                >
                    <View className="event-row-inner" style={{ flex: 1, flexDirection: "row", justifyContent: "flex-start", maxHeight: "100%" }}>
                        <View style={{ width: "100%" }}>
                            <div
                                className="event-card"
                                role="button"
                                tabIndex={0}
                                onClick={() => setOpenEventId(event.eventId)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" || e.key === " ") {
                                        e.preventDefault();
                                        setOpenEventId(event.eventId);
                                    }
                                }}
                            >
                                <div className="event-container">
                                    <div className="event-thumbnail-container">
                                        {loadingThumbs[event.eventId] ? (
                                            <div className="event-thumbnail-placeholder">
                                                <ThreeDots visible={true} color={"#262626"} />
                                            </div>
                                        ) : thumbs[event.eventId] ? (
                                            <img
                                                src={thumbs[event.eventId].url}
                                                alt=""
                                                className="event-thumbnail"
                                            />
                                        ) : (
                                            <div className="event-thumbnail-placeholder">
                                                <span>No thumbnail</span>
                                            </div>
                                        )}
                                    </div>
                                    <div className="event-details">
                                        <div className="event-when">
                                            <span className="event-time">{formatEventTimelineTime(event.startDate)}</span>
                                            <span className="event-date">{formatEventTimelineDate(event.startDate)}</span>
                                        </div>
                                        <div className="event-camera">{readableMonitorName(filterMonitorsByMonitorId(monitors, event.monitorId))}</div>
                                        {(detectionNames.length > 0 || isUnverified) && (
                                            <div className="event-badges">
                                                {detectionNames.map((name) => (
                                                    <span key={name} className="event-badge">{name}</span>
                                                ))}
                                                {isUnverified && (
                                                    <span className="event-badge event-badge--unverified">Unverified</span>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </View>
                    </View>
                </div>
            );
        }

        const timelineGroups = useEnhancedMotionHistory ? groupEventsForTimeline(events) : [];
        const groupedRows = [];
        if (useEnhancedMotionHistory) {
            for (const group of timelineGroups) {
                groupedRows.push(
                    <div
                        key={`heading-${group.id}`}
                        className="events-hour-heading"
                        role="separator"
                        aria-label={`${group.label}, ${group.count} events`}
                    >
                        <span className="events-hour-heading-label">{group.label}</span>
                        <span className="events-hour-heading-count">
                            {group.count} {group.count === 1 ? "event" : "events"}
                        </span>
                    </div>
                );
                for (const event of group.events) {
                    const row = renderEventRow(event);
                    if (row) groupedRows.push(row);
                }
            }
        }

        const legacyRows =
            events && events.length > 0
                ? events.map((event) => renderEventRow(event)).filter(Boolean)
                : [];

        return events && events.length > 0 ? (
            useEnhancedMotionHistory
                ? groupedRows.length > 0
                    ? groupedRows
                    : null
                : legacyRows.length > 0
                    ? legacyRows
                    : null
        ) : events && events.length === 0 && (
            <ListGroup key={"No Events."} className="events-list-empty" style={{fontSize:"18px",textAlign:"center"}}>
                {time > 10 ? "No Events Found, consider changing your filter parameters above" : ""}
            </ListGroup>
        );
        // ) : (
        //     <ListGroupItem key={"No Events Yet"} style={{fontSize: "18px",textAlign:"center"}}>
        //         {time > 15 ? "Please Wait. Our servers are a little busy. Events will load momentarily." : time%5===4 ? "Loading...." : time %5===3 ? "Loading..." : time%5===2 ? "Loading.." : "Loading."}
        //     </ListGroupItem>
        // ));
    } 

    async function onSort(eventKey) {
        var tempEP = cloneEventParameters(eventParameters);
        tempEP.pageNumber = 0;
        tempEP.sortParameterNumber = Number(eventKey);
        setEventParameters(tempEP);
        changePage(0,Number(eventKey),0,eventParameters.selectedFilters,eventParameters.realMotion,eventParameters.startDate,eventParameters.endDate,eventParameters.cars,eventParameters.persons);
    }

    async function onFilter(eventKey) {
        var tempEP = cloneEventParameters(eventParameters);
        tempEP.selectedFilters[filterOptions[Number(eventKey)]] = !tempEP.selectedFilters[filterOptions[Number(eventKey)]];
        setEventParameters(tempEP);
        changePage(0,eventParameters.sortParameterNumber,0,tempEP.selectedFilters,eventParameters.realMotion,eventParameters.startDate,eventParameters.endDate,eventParameters.cars,eventParameters.persons);
    }

    // TODO: reenable this 
    // async function onFilterDayLight(eventKey) {
    //     var tempSelectedFilters = JSON.parse(JSON.stringify(daylightFilter));
    //     tempSelectedFilters[eventKey] = !tempSelectedFilters[eventKey];
    //     setDaylightFilter(tempSelectedFilters);
    //     changePage(0,sortParameterNumber,pageNumber,tempSelectedFilters);
    // }
    
    function renderCamEvents() {
        const tooltip = (
            <Tooltip id="refresh" style={{fontSize: "18px"}}>
                Refresh to load new events
            </Tooltip>
        );
        const realMotionTooltip = (
            <Tooltip id="realMotion" style={{fontSize:"18px"}} disabled={buttonSize==="small"}>
                {eventParameters.realMotion ? "Click to show all unfiltered motion" : "Click to show only verified motion"}
            </Tooltip>
        )
        const carsTooltip = (
            <Tooltip id="carsTT" style={{fontSize:"18px"}} disabled={buttonSize==="small"}>
                {eventParameters.cars ? "Click to remove vehicle events" : "Click to show vehicle events"}
            </Tooltip>
        )
        const personsTooltip = (
            <Tooltip id="personsTT" style={{fontSize:"18px"}} disabled={buttonSize==="small"}>
                {eventParameters.persons ? "Click to remove person events" : "Click to show person events"}
            </Tooltip>
        )
        const filterTooltip = (
            <Tooltip id="filter" style={{fontSize:"18px"}} disabled={buttonSize==="small"}>
                Narrow your filter parameters
            </Tooltip>
        )
        const zonesTooltip = (
            <Tooltip id="zones" style={{fontSize:"18px"}} disabled={buttonSize==="small"}>
                Edit the motion zones for this Camera
            </Tooltip>
        )
        const buttonType = "default";
        const ThreeDotLoader = (
            <View style={{flex:1,flexDirection:"row",justifyContent:"center"}}><ThreeDots visible={true} color={"#262626"} /></View>
        );
        const useTimelineScrollLayout =
            usesNewestTimeline(eventParameters.sortParameterNumber) &&
            cap &&
            monitors;
        const showInfiniteList =
            cap &&
            monitors &&
            (useTimelineScrollLayout ||
                (cap.architecture && cap.architecture.includes("JETSON")));

        const toolbarMobile = buttonSize === "small";
        const productLabel = cap && cap.architecture ?
            (cap.architecture.endsWith('2CAM') ? 'JobSight' :
             cap.architecture.endsWith('4CAM') ? 'JobSight PRO' :
             'Legacy') : null;
        const statusInfo = cap ? (() => {
            switch (cap.health) {
                case 'ONLINE': return { text: 'ONLINE', cls: 'online' };
                case 'POWER_LOSS': return { text: 'POWER OUTAGE', cls: 'power' };
                case 'BATTERY': return { text: 'BATTERY', cls: 'battery' };
                case 'ERROR': return { text: 'CELL SIGNAL WEAK', cls: 'signal' };
                default: return cap.health ? { text: cap.health, cls: 'default' } : null;
            }
        })() : null;
        const toolbar = (
                <View
                    className={
                        useTimelineScrollLayout
                            ? "events-timeline-toolbar"
                            : "events-toolbar-sticky"
                    }
                >
                    <nav className="brand-breadcrumb">
                        <Link to="/dashboard">Dashboard</Link>
                        <span className="brand-breadcrumb-sep">/</span>
                        <Link
                            to={`/caps/${props.match.params.capid}`}
                            onClick={() => removeDefaultEventParameters()}
                        >
                            {productLabel || (cap && cap.name)}
                        </Link>
                        <span className="brand-breadcrumb-sep">/</span>
                        <span className="brand-breadcrumb-current">Motion History</span>
                    </nav>
                    <div className="events-title-row">
                        {cap && <h1 className={`brand-cap-title ${getCapTitleLengthClass(cap.name)}`}>{cap.name}</h1>}
                        {statusInfo && (
                            <span className={`brand-status-badge brand-status--${statusInfo.cls}`}>
                                {statusInfo.text}
                            </span>
                        )}
                    </div>
                    <div
                        className={
                            toolbarMobile
                                ? "events-toolbar-controls events-toolbar-controls--mobile"
                                : "events-toolbar-controls"
                        }
                    >
                        <div
                            className={
                                toolbarMobile
                                    ? "events-toolbar-controls-date events-toolbar-controls-date--mobile"
                                    : "events-toolbar-controls-date"
                            }
                        >
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <ThemeProvider theme={buttonSize==="small" ? brandPickerThemeMobile : brandPickerThemeDesktop}>
                                    <div className="events-toolbar-controls-date-input">
                                        <Glyphicon glyph="time" className="events-date-glyph" />
                                        {buttonSize==="small"?(
                                            <MobileDateTimePicker 
                                                format={isToday(eventParameters.endDate) ? "'Date     |     Today'" : "'Date     |     'MMM d"}
                                                value={ensurePickerWallClockDate(eventParameters.endDate)} 
                                                onChange={changeEndTime} 
                                                // minDate={eventParameters.startDate}
                                                maxDate={addDaysToDate(new Date(),1)}
                                                InputProps={{disableUnderline:true}}
                                            />
                                        ):(
                                            <DesktopDateTimePicker 
                                                format={isToday(eventParameters.endDate) ? "'Date      |      Today'" : "'Date      |      'MMM d"}
                                                value={ensurePickerWallClockDate(eventParameters.endDate)} 
                                                onChange={changeEndTime} 
                                                // minDate={eventParameters.startDate}
                                                maxDate={addDaysToDate(new Date(),1)}
                                                InputProps={{disableUnderline:true}}
                                            />
                                        )}
                                    </div>
                                    </ThemeProvider>
                                    {/* <View style={buttonSize==="small"?{fontSize:"20px",paddingLeft:"5px",paddingTop:"7px"}:{fontSize:"35px",paddingLeft:"15px",paddingTop:"7px"}}>
                                        <Glyphicon glyph="arrow-right" />
                                    </View> */}
                                    {/* <View style={{paddingLeft:buttonSize==="small"?"5px":"15px",paddingTop:"0px"}}>
                                        {buttonSize==="small"?(
                                            <MobileDateTimePicker 
                                                format={"MMM d"} 
                                                value={eventParameters.startDate} 
                                                onChange={changeStartTime} 
                                                maxDate={new Date()} 
                                                InputProps={{disableUnderline:true}}
                                            />
                                        ):(
                                            <DesktopDateTimePicker 
                                                format={"MMM d"} 
                                                value={eventParameters.startDate} 
                                                onChange={changeStartTime} 
                                                maxDate={new Date()} 
                                                InputProps={{disableUnderline:true}}
                                            />
                                        )}
                                    </View> */}
                                </MuiPickersUtilsProvider>
                        </div>
                        <div className="events-toolbar-controls-filter">
                            <OverlayTrigger placement="bottom" overlay={filterTooltip}>
                                <Button
                                    className="btn-brand-underline events-filter-button"
                                    onClick={e => setShowFilterModal(!showFilterModal)}
                                    disabled={isLoading}
                                >
                                    <Glyphicon glyph="cog" className="events-glyph-front" />
                                    Filter
                                </Button>
                            </OverlayTrigger>
                        </div>
                        {/* <View style={{flex: 1, flexDirection: "row", justifyContent: "flex-end"}}>
                            <OverlayTrigger placement="bottom" overlay={zonesTooltip}>
                                <Button
                                    bsStyle="success"
                                    bsSize={buttonSize}
                                    disabled={!(cap && (cap.health==="ONLINE" || cap.health==="BATTERY"))}
                                    style={buttonSize=="small"?{width:"60px",height:"37px"}:{width:"100px",height:"52px"}}
                                    onClick={() => setShowZonesModal(true)}
                                >
                                    Zones
                                </Button>
                            </OverlayTrigger>
                        </View> */}
                        
                        {/* COME BACK TO THIS --> PLAYBACK SPEED
                        <View style={{flex:1, flexDirection:"row", justifyContent:"flex-end"}}>
                            <DropdownButton
                                bsStyle="default"
                                bsSize={buttonSize}
                                title={<Glyphicon style={{paddingRight:"10px"}} glyph="play-circle" />}
                                style={buttonSize=="small"?{width:"60px",height:"37px"}:{width:"100px",height:"52px"}}
                                key={1}
                                id={"playbackspeed"}
                            >
                                <MenuItem eventKey="1" onClick={() => setPlaybackSpeed(1)}>1x</MenuItem>
                                <MenuItem eventKey="4" onClick={() => setPlaybackSpeed(4)}>4x</MenuItem>
                            </DropdownButton>
                        </View> */}
                        {/* <View style={{flex:1, flexDirection:"row",justifyContent:"flex-end", zIndex:1000,paddingBottom:"0px",flexWrap:"wrap",flexGrow:2}}>
                            <View style={{paddingRight: "5px", paddingBottom:"5px"}}>
                                <OverlayTrigger placement="left" overlay={tooltip}>
                                    <Button
                                        bsStyle={buttonType}
                                        bsSize={buttonSize}
                                        onClick={() => {changePage(0,eventParameters.sortParameterNumber,0,eventParameters.selectedFilters,eventParameters.realMotion,eventParameters.startDate,eventParameters.endDate,eventParameters.cars,eventParameters.persons)}}
                                    >
                                        <Glyphicon glyph="refresh"></Glyphicon>
                                    </Button>
                                </OverlayTrigger>
                            </View>
                            <View style={{paddingRight:"5px"}}>
                                <DropdownButton
                                    bsStyle={buttonType}
                                    bsSize={buttonSize}
                                    title={sorts[eventParameters.sortParameterNumber]}
                                    key="1"
                                    id="sortDropdownSelector"
                                    sytle={{zIndex:1000}}
                                >
                                    {sorts.map((sort,i) => (
                                        <MenuItem key={sort} eventKey={i.toString()} onSelect={onSort}>{sort}</MenuItem>
                                    ))}
                                </DropdownButton>
                            </View>
                            { events && (
                                <React.Fragment>
                                    <View style={{paddingRight: "5px"}}>
                                        <Dropdown
                                            bsStyle={buttonType}
                                            bsSize={buttonSize}
                                            key="1"
                                            id="filterDropdownSelector"
                                            style={{zIndex:1000}}
                                        >
                                            <Dropdown.Toggle noCaret>
                                                <Glyphicon glyph="filter" />
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                {filterOptions.map((f,i)=>(
                                                    <MenuItem key={f} eventKey={i.toString()} onSelect={onFilter}>
                                                        <Checkbox onChange={() => void(0)} checked={eventParameters.selectedFilters[f]||false} value={f || ''}>{f}</Checkbox>
                                                    </MenuItem>
                                                ))}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </View>
                                    {cap && cap.architecture && ( cap.architecture.includes("CHLORINE") || cap.architecture.includes("BROMINE") || cap.architecture.includes("ADAFRUIT") || cap.architecture.includes("XAVIER")) && (
                                        <React.Fragment>
                                            <View style={{paddingRight:"5px"}}>
                                                <OverlayTrigger overlay={carsTooltip} placement="top">
                                                    <Button 
                                                        bsStyle={eventParameters.cars ? "success" : buttonType }
                                                        bsSize={buttonSize}
                                                        onClick={() => {changePage(0,eventParameters.sortParameterNumber,0,eventParameters.selectedFilters,eventParameters.realMotion,eventParameters.startDate,eventParameters.endDate,!eventParameters.cars,eventParameters.persons)}}
                                                    >
                                                        <svg xmlns="http://www.w3.org/2000/svg" width={buttonSize==="small"?"12":"20"} height={buttonSize==="small"?"12":"20"} fill="currentColor" className="bi bi-car-front-fill" viewBox="0 0 16 16">
                                                            <path fillRule="evenodd" d="M2.52 3.515A2.5 2.5 0 0 1 4.82 2h6.362c1 0 1.904.596 2.298 1.515l.792 1.848c.075.175.21.319.38.404.5.25.855.715.965 1.262l.335 1.679c.033.161.049.325.049.49v.413c0 .814-.39 1.543-1 1.997V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.338c-1.292.048-2.745.088-4 .088s-2.708-.04-4-.088V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.892c-.61-.454-1-1.183-1-1.997v-.413a2.5 2.5 0 0 1 .049-.49l.335-1.68c.11-.546.465-1.012.964-1.261a.807.807 0 0 0 .381-.404l.792-1.848ZM3 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm10 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM6 8a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2H6ZM2.906 5.189l.956-1.913A.5.5 0 0 1 4.309 3h7.382a.5.5 0 0 1 .447.276l.956 1.913a.51.51 0 0 1-.497.731c-.91-.073-3.35-.17-4.597-.17-1.247 0-3.688.097-4.597.17a.51.51 0 0 1-.497-.731Z"/>
                                                        </svg>
                                                    </Button>
                                                </OverlayTrigger>
                                            </View>
                                            <View style={{paddingRight:"5px"}}>
                                                <OverlayTrigger overlay={personsTooltip} placement="top">
                                                    <Button 
                                                        bsStyle={eventParameters.persons ? "success" : buttonType }
                                                        bsSize={buttonSize}
                                                        onClick={() => {changePage(0,eventParameters.sortParameterNumber,0,eventParameters.selectedFilters,eventParameters.realMotion,eventParameters.startDate,eventParameters.endDate,eventParameters.cars,!eventParameters.persons)}}
                                                    >
                                                        <svg xmlns="http://www.w3.org/2000/svg" width={buttonSize==="small"?"12":"20"} height={buttonSize==="small"?"12":"20"} fill="currentColor" className="bi bi-people" viewBox="0 0 16 16">
                                                            <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8zm-7.978-1A.261.261 0 0 1 7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002a.274.274 0 0 1-.014.002H7.022zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM6.936 9.28a5.88 5.88 0 0 0-1.23-.247A7.35 7.35 0 0 0 5 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816zM4.92 10A5.493 5.493 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275zM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"/>
                                                        </svg>
                                                    </Button>
                                                </OverlayTrigger>
                                            </View>
                                        </React.Fragment>
                                    )}
                                    <View style={{paddingRight:"5px"}}>
                                        <OverlayTrigger overlay={realMotionTooltip} placement="top">
                                            <Button
                                                bsStyle={eventParameters.realMotion ? buttonType : "danger"}
                                                bsSize={buttonSize}
                                                onClick={() => {changePage(0,eventParameters.sortParameterNumber,0,eventParameters.selectedFilters,!eventParameters.realMotion,eventParameters.startDate,eventParameters.endDate,eventParameters.cars,eventParameters.persons)}}
                                            >
                                                <Glyphicon glyph="asterisk" />
                                            </Button>
                                        </OverlayTrigger>
                                    </View>
                                </React.Fragment>
                            )}
                            <View>
                                {renderPageButtons()}
                            </View>
                        </View> */}
                    </div>
                </View>
        );

        const eventList = showInfiniteList && (
            <InfiniteScroll
                scrollableTarget={
                    useTimelineScrollLayout ? "events-timeline-scroll" : undefined
                }
                dataLength={events ? events.length : 0}
                next={nextPage}
                hasMore={
                    usesNewestTimeline(eventParameters.sortParameterNumber)
                        ? hasMoreOlderTimeline
                        : nextPageEvents == null || nextPageEvents.length !== 0
                }
                loader={ThreeDotLoader}
                endMessage={
                    <p style={{ textAlign: "center" }}>
                        {events && events.length > 0 && (
                            <b>Adjust Date Filter to Find More Events</b>
                        )}
                    </p>
                }
                refreshFunction={refreshPage}
                pullDownToRefresh={!useTimelineScrollLayout}
                pullDownToRefreshThreshold={50}
                pullDownToRefreshContent={
                    <h3 style={{ textAlign: "center" }}>
                        &#8595; Pull down to refresh
                    </h3>
                }
                releaseToRefreshContent={
                    <h3 style={{ textAlign: "center" }}>
                        &#8593; Release to refresh
                    </h3>
                }
            >
                <div
                    id="List-of-events"
                    className={`events-list ${useEnhancedMotionHistory ? "events-list--enhanced" : "events-list--legacy"}`}
                >
                    {useTimelineScrollLayout && hasMoreNewerTimeline && (
                        <div
                            ref={loadNewerSentinelRef}
                            className="events-timeline-load-newer"
                        >
                            {loadingNewerUi ? (
                                ThreeDotLoader
                            ) : (
                                <span>More recent events above</span>
                            )}
                        </div>
                    )}
                    {renderEventsList()}
                </div>
            </InfiniteScroll>
        );

        if (useTimelineScrollLayout) {
            return (
                <div className="events-timeline-page">
                    {toolbar}
                    <div
                        id="events-timeline-scroll"
                        ref={scrollContainerRef}
                        className="events-timeline-scroll"
                    >
                        {eventList}
                    </div>
                </div>
            );
        }

        return (
            <View style={{ flex: 1, flexDirection: "column", zIndex: 1000 }}>
                {toolbar}
                {eventList}
            </View>
        );
    }

    function renderNone() {
        return (
            <div style={{paddingTop: "100px", textAlign: "center"}}>
                <h3>Your CAP is not online or is not set up yet, please contact Bedrock Wireless for assistance.</h3>
            </div>
        );
    }
    
    const handleContainerMouseDown = (e) => {
        // Prevent middle mouse button (wheel click) default behavior
        if (e.button === 1) {
            e.preventDefault();
            e.stopPropagation();
            return false;
        }
    };

    return (
        <div 
            className="Events modal-container"
            onMouseDown={handleContainerMouseDown}
            onContextMenu={(e) => {
                // Also prevent right-click context menu if needed
                // e.preventDefault();
            }}
        >
            {renderError ? renderNone() : (
                renderCamEvents()
            )}
            <MotionHistoryFilterModal
                show={showFilterModal}
                setShowFilterModal={setShowFilterModal}
                eventParamaters={eventParameters}
                setEventParameters={setEventParameters}
                applyFilters={refreshPage}
                architecture={cap && cap.architecture && cap.architecture.includes("2CAM")}
                props={props}
            />
            <FootageModal
                show={showFootage}
                setShowFootage={setShowFootage}
                footageMonitor={footageMonitor}
                roughStartDate={footageStartDate}
                cameraOffsetMinutes={footageCameraOffsetMinutes}
                setFootageCameraOffsetMinutes={setFootageCameraOffsetMinutes}
                key={cap ? cap.capid : "trash"}
                cap={cap}
                props={props}
            />
            {cap && (
                <ZonesModal
                    show={showZonesModal}
                    onHide={() => setShowZonesModal(false)}
                    cap={cap}
                    setErrorMessage={props.setErrorMessage}
                    setErrorStatus={props.setErrorStatus}
                    setShowError={props.setShowError}
                />
            )}
            {openEventId && cap && (
                <div
                    className="brand-overlay event-overlay"
                    onMouseDown={(e) => {
                        // Close unless the press started on actual content (buttons, video, image)
                        if(e.target.closest && e.target.closest(".motion-event-controls, .motion-event-image, .video-react, .motion-event-error, .brand-overlay-close, .event-overlay-nav")) return;
                        setOpenEventId(null);
                    }}
                >
                    <button
                        type="button"
                        className="brand-overlay-close"
                        aria-label="Close event"
                        onClick={() => setOpenEventId(null)}
                    >
                        &times;
                    </button>
                    <div className="event-overlay-row">
                    <button
                        type="button"
                        className={`event-overlay-nav event-overlay-nav--prev ${getAdjacentEventId(-1) ? "" : "event-overlay-nav--hidden"}`}
                        aria-label="Previous event"
                        onClick={() => setOpenEventId(getAdjacentEventId(-1))}
                    >
                        <Glyphicon glyph="chevron-left" />
                    </button>
                    <div className="event-overlay-stage">
                        <MotionEvent
                            key={openEventId}
                            eventId={openEventId}
                            reloadEvents={() => {
                                setOpenEventId(null);
                                refreshPage();
                            }}
                            playbackSpeed={playbackSpeed}
                            setShowFootage={(v) => {
                                if(v) setOpenEventId(null);
                                setShowFootage(v);
                            }}
                            setFootageStartDate={setFootageStartDate}
                            setFootageMonitor={setFootageMonitor}
                            setFootageCameraOffset={setFootageCameraOffsetMinutes}
                            capArchitecture={cap && cap.architecture && (cap.architecture.includes("4CAM") || cap.architecture.includes("2CAM"))}
                            props={props}
                        />
                    </div>
                    <button
                        type="button"
                        className={`event-overlay-nav event-overlay-nav--next ${getAdjacentEventId(1) ? "" : "event-overlay-nav--hidden"}`}
                        aria-label="Next event"
                        onClick={() => setOpenEventId(getAdjacentEventId(1))}
                    >
                        <Glyphicon glyph="chevron-right" />
                    </button>
                    </div>
                </div>
            )}
            {/* {events && allEmails && renderSharingModal()} */}
        </div>
    )
}